<div class="static-desktop-heading">
  {{ 'modelPortfolios.header' | translate }}
</div>

<div class="desktop-aligment">
  <div class="desktop-image-container desktop-image-container--model-portfolios"></div>

  <div class="desktop-column">
    <div class="static-heading">
      {{ 'modelPortfolios.subHeader' | translate }}
    </div>

    <div class="static-text" [innerHTML]="'modelPortfolios.text1' | translate | htmlFormat"></div>

    <div class="phone-image-container">
      <img src="/assets/images/static-pages/foto-modelova-portfolia.jpg" alt="model portfolio banner">
    </div>

    <div class="static-text" [innerHTML]="'modelPortfolios.text2' | translate | htmlFormat"></div>
  </div>
</div>

<libero-static-page-footer></libero-static-page-footer>
